import { useEffect, useState } from "react";
import { CheckCircle, Loader2, XCircle } from "lucide-react";
import Header from "@/components/Header";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccess() {
  const [status, setStatus] = useState("loading");
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }
    pollStatus(sessionId, 0);
  }, []);

  const pollStatus = async (sessionId, attempt) => {
    if (attempt >= 5) {
      setStatus("timeout");
      return;
    }
    try {
      const res = await fetch(`${API}/api/checkout/status/${sessionId}`);
      const d = await res.json();
      setData(d);
      if (d.payment_status === "paid") {
        setStatus("success");
      } else if (d.status === "expired") {
        setStatus("expired");
      } else {
        setTimeout(() => pollStatus(sessionId, attempt + 1), 2000);
      }
    } catch {
      setTimeout(() => pollStatus(sessionId, attempt + 1), 2000);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Header />
      <div className="pt-[120px] pb-20 flex items-center justify-center">
        <div className="max-w-md w-full mx-6 bg-white rounded-xl border border-slate-200 p-10 text-center shadow-lg">
          {status === "loading" && (
            <>
              <Loader2 className="w-16 h-16 text-[#00A8FF] mx-auto mb-6 animate-spin" />
              <h1 className="font-['Outfit'] text-2xl font-bold text-[#0A1628] mb-2">A processar pagamento...</h1>
              <p className="text-slate-500 text-sm">Aguarda enquanto confirmamos o teu pagamento.</p>
            </>
          )}

          {status === "success" && (
            <>
              <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-10 h-10 text-green-500" />
              </div>
              <h1 className="font-['Outfit'] text-2xl font-bold text-[#0A1628] mb-2">Pagamento Confirmado!</h1>
              <p className="text-slate-500 text-sm mb-6">
                O teu pagamento de €{data?.amount_total ? (data.amount_total / 100).toFixed(2) : "--"} foi processado com sucesso.
              </p>
              <p className="text-slate-400 text-xs mb-8">Receberás um email de confirmação em breve.</p>
              <a
                href="/"
                className="inline-block bg-gradient-to-r from-[#F59E0B] to-[#D97706] text-white font-bold py-3 px-8 rounded-lg text-sm shadow-lg shadow-amber-500/20"
              >
                Voltar à Página Principal
              </a>
            </>
          )}

          {(status === "error" || status === "expired" || status === "timeout") && (
            <>
              <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-10 h-10 text-red-500" />
              </div>
              <h1 className="font-['Outfit'] text-2xl font-bold text-[#0A1628] mb-2">
                {status === "expired" ? "Sessão Expirada" : "Erro no Pagamento"}
              </h1>
              <p className="text-slate-500 text-sm mb-8">
                {status === "expired"
                  ? "A sessão de pagamento expirou. Tenta novamente."
                  : "Não foi possível confirmar o pagamento. Contacta-nos se o valor foi debitado."}
              </p>
              <a
                href="/#precos"
                className="inline-block bg-[#0A1628] text-white font-bold py-3 px-8 rounded-lg text-sm"
              >
                Tentar Novamente
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
